<template>
    <div>
        <div class="row text-center my-3">
            <div class="col-sm-3 text-left">{{ user.name }}</div>
            <div class="col-sm-3 text-left">{{ user.surname }}</div>
            <div class="col-sm-6 text-right">
                <template v-if="user.role !== 'manager'">
                    <font-awesome-icon v-if="isAllTestsPassed"
                                       icon="check-circle"
                                       class="ds-btn--icon-green mr-3"
                                       v-b-tooltip.hover
                                       :title="`Visi testi izpildīti veiksmīgi ${user.lastExecusionTime}`"
                    />
                    <font-awesome-icon v-else
                                       icon="times-circle"
                                       class="ds-btn--icon-red mr-3"
                                       v-b-tooltip.hover title="Kāds no testiem nav izpildīts"/>
                </template>
                <button class="ds-btn mr-1" @click="showModal(user)">
                    <font-awesome-icon icon="eye" class="mr-1"/>
                </button>
                <button class="ds-btn ds-btn--danger" @click="handleUserRemoval">
                    <font-awesome-icon icon="trash"/>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import {User} from '../../vuex/modules/user/models/user.models';
    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as rootStoreTypes from '../../vuex/root.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'users-list-item',
        props: {
            user: {
                type: User,
                required: true,
            }
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyUsers: companyStoreTypes.SET_CURRENT_COMPANY_USERS
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                removeUser: userStoreTypes.ACTION_REMOVE_USER,
                /** @type {function|*} */
                getUsers: userStoreTypes.ACTION_GET_USERS,
                /** @type {function|*} */
                showModal: userStoreTypes.ACTION_SHOW_MODAL,
            }),
            async handleUserRemoval() {
                const hasConfirmed = await this.$bvModal.msgBoxConfirm('Esi pārliecināts?', {
                    okTitle: 'Jā',
                    cancelTitle: 'Nē',
                });

                if (!hasConfirmed) {
                    return;
                }

                try {
                    await this.removeUser({
                        companyId: this.$route.params.companyId || this.currentUser.company._id,
                        userId: this.user._id
                    });
                    this.setAlertData({type: 'primary', message: 'Darbinieks izdzēsts!'});
                    const users = await this.getUsers({companyId: this.$route.params.companyId || this.currentUser.company._id});
                    this.setCurrentCompanyUsers(users);
                } catch (err) {
                    //
                }
            },

            getFormResults(testData, {requiredDocuments}) {
                const hasPassed = requiredDocuments.filter(
                    ({documentForm: {documentFormResults}}) => documentFormResults.length && documentFormResults
                        .map(results => {
                            const {updatedAt} = results;

                            //Compares tests when it was last updated
                            testData.lastExecusionTime = +new Date(updatedAt) > +new Date(testData.lastExecusionTime)
                                ? new Date(updatedAt)
                                : 0;

                            return results;
                        })
                        .filter(({isPassed}) => isPassed).length
                ).length;

                if (!hasPassed) {
                    testData.isPassed = hasPassed;
                }

                return testData;
            },

            getShortDateFormat(date) {
                return `${date.getDate()}-${(date.getMonth() + 1)}-${date.getFullYear()}`;
            }
        },
        computed: {
          ...mapGetters('auth', {
            /** @type {CurrentUser|*} */
            currentUser: authStoreTypes.GET_CURRENT_USER,
          }),
          isAllTestsPassed() {
            if (!this.user.documentFormResult.length) {
              return false;
            }

            const {isPassed} = this.user.documentFormResult.reduce(this.getFormResults, {
              isPassed: true,
              lastExecusionTime: 0
            });

            // this.user.lastExecusionTime = lastExecusionTime ? this.getShortDateFormat(lastExecusionTime) : '';

            return isPassed;
          },
        }
    }
</script>